export default function Card3Icon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h16v16H0z" />
        <path d="M8 12.92c.093 0 .22-.04.347-.103 2.812-1.426 3.755-2.207 3.755-3.955V5.263c0-.62-.225-.854-.752-1.079-.508-.21-2.286-.83-2.774-.991A2.15 2.15 0 0 0 8 3.1c-.186 0-.396.04-.576.093-.493.156-2.266.781-2.774.991-.532.22-.756.459-.756 1.08v3.598c0 1.748.981 2.466 3.754 3.955a.8.8 0 0 0 .352.102zM5.812 8.104c0-.068.035-.151.088-.215l2.715-3.354c.24-.289.625-.088.489.268l-.87 2.315H9.87c.147 0 .264.107.264.253a.357.357 0 0 1-.088.215L7.33 10.942c-.24.288-.625.088-.488-.269l.869-2.314H6.076a.254.254 0 0 1-.263-.254z" fill="#383A3D" fillRule="nonzero" />
      </g>
    </svg>
  );
};
